import React from 'react';


const LoginHeader = () => {
  return (
    <div className="text-center mb-8">
      <div className="flex justify-center mb-4">
        <div className="w-16 h-16 bg-gradient-to-br from-primary to-accent rounded-lg flex items-center justify-center shadow-lg">
          <div className="text-white font-bold text-2xl">T</div>
        </div>
      </div>
      
      <h1 className="text-3xl font-bold text-foreground mb-2">
        Welcome Back
      </h1>
      
      <p className="text-muted-foreground">
        Sign in to access your bike trick analysis and upgrade recommendations
      </p>
    </div>
  );
};

export default LoginHeader;